import React from "react";
import { siteContent } from "../content";
import Section from "../components/Section";

export default function Highlights() {
  const { artists, concerts, gallery } = siteContent;

  return (
    <div className="space-y-6">
      <Section
        eyebrow="Highlights"
        title="Career milestones & performances"
        description="Curated highlights from films, albums, viral covers, and concerts across India and abroad."
      >
        <div className="grid gap-6 md:grid-cols-2">
          {artists.map((artist) => (
            <div
              key={`${artist.name}-career`}
              className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-lg p-6 shadow-xl"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="h-2 w-2 rounded-full bg-amber-300" />
                <div>
                  <p className="text-sm uppercase tracking-[0.2em] text-amber-200/80">
                    {artist.role}
                  </p>
                  <h3 className="text-white font-semibold text-xl">
                    {artist.name}
                  </h3>
                </div>
              </div>
              <div className="space-y-2 text-gray-200 text-sm">
                {artist.achievements.map((item) => (
                  <div
                    key={item}
                    className="rounded-xl border border-white/5 bg-black/40 px-3 py-2"
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section
        eyebrow="Awards"
        title="Awards & recognition"
        description="Honours that celebrate dedication to music and performance."
      >
        <div className="grid gap-6 md:grid-cols-2">
          {artists.map((artist) => (
            <div
              key={`${artist.name}-awards`}
              className="rounded-3xl border border-amber-200/20 bg-amber-300/5 p-6 shadow-xl"
            >
              <h4 className="text-white font-semibold text-lg mb-3 flex items-center gap-2">
                <span className="h-2 w-2 rounded-full bg-amber-300" />
                {artist.name}
              </h4>
              <div className="flex flex-wrap gap-2">
                {artist.awards.map((award) => (
                  <span
                    key={award}
                    className="text-xs font-semibold text-amber-200 border border-amber-200/40 rounded-full px-3 py-1 bg-white/5"
                  >
                    {award}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section
        eyebrow="Concerts"
        title="Major live concerts"
        description="Select shows that brought the duo to audiences across India and overseas."
      >
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 text-gray-200 shadow-xl">
          {concerts}
        </div>
      </Section>

      <Section
        eyebrow="Gallery"
        title="On-stage energy"
        description="Moments from shows, rehearsals, and live sessions."
      >
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {gallery.map((src) => (
            <img
              key={src}
              src={src}
              alt="Highlights gallery"
              className="rounded-2xl object-cover h-40 w-full border border-white/10 shadow-lg"
            />
          ))}
        </div>
      </Section>
    </div>
  );
}
